import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'
import { onlyTypename } from 'js/lib/helpers/onlyTypename'
import { GET_ADD_ISSUE_ARTICLE } from 'js/magazine-issue/AddEditArticle/Add/Add.queries'
import AddEditForm from 'js/magazine-issue/AddEditArticle/AddEditForm'

const Add = () => {
    const { t } = useTranslation()
    const { containerGuid } = useParams()

    const { data, loading } = useQuery(GET_ADD_ISSUE_ARTICLE, {
        variables: {
            containerGuid,
        },
    })

    if (loading) {
        return null
    }

    const magazineIssue = onlyTypename(data?.entity, 'MagazineIssue')

    const { site, viewer } = data || {}

    if (!magazineIssue?.canEdit) {
        return <NotFound />
    }

    return (
        <AddEditForm
            site={site}
            viewer={viewer}
            container={magazineIssue}
            title={t('entity-magazine.create-article')}
        />
    )
}

export default Add
